const ReducedMotionQuery = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion() {
  return typeof window.matchMedia === 'function' && window.matchMedia(ReducedMotionQuery).matches;
}

export function scrollToAnchorTarget(event) {
  const targetElement = document.getElementById(decodeURIComponent(event.currentTarget.hash.slice(1)));
  if (!targetElement) return;
  event.preventDefault();
  targetElement.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  targetElement.focus({ preventScroll: true });
}